<h2 mat-dialog-title class="p-l-25">
  {{ 'broker.compensation.contactus.ContactUs' | translate }}
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="contact-us-dialog p-l-50">
  <br />
  <div class="font-wt-300">
    {{ 'broker.compensation.contactus.ProducerOperations' | translate }}
  </div>
  <div>{{ 'broker.compensation.contactus.OfficePhone' | translate }}</div>
  <div>{{ 'broker.compensation.contactus.Fax' | translate }}</div>
  <div>{{ 'broker.compensation.contactus.Email' | translate }}</div>
  <div>
    <br />
    <button
      mat-dialog-close
      aria-label="Submit Default Client"
      data-test-id="btnSetDefaultClientModalSbmt"
      mat-raised-button
      cg-mat-btn-type="primary"
      class="btn-medium btn-appy"
    >
      Close
    </button>
    <br />
  </div>
</mat-dialog-content>
